function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/helpers';
import { LANG } from '../utils/constant';
import { API_URL } from '../utils/constant';
import _deburr from 'lodash/deburr';
import { throttle, debounce } from 'throttle-debounce';

var Search = /*#__PURE__*/function (_Component) {
  _inherits(Search, _Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "doSearchURL", function (val) {
      if (val !== '') {
        window.location.href = "/".concat(LANG, "/shop/#/search/").concat(val);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (evt) {
      evt.preventDefault();

      _this.closeSearchBar();

      if (_this.searchRef.current.value !== '') {
        _this.doSearchURL(_this.searchRef.current.value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "autoCompleteClick", function (val) {
      _this.setState({
        search_text: val,
        q: val,
        autoComplete: []
      }, _this.doSearchURL(val));
    });

    _defineProperty(_assertThisInitialized(_this), "setSearchTxt", function (event) {
      _this.setState({
        search_text: event.target.value,
        q: event.target.value
      }, function () {
        var q = _this.state.q;

        if (q.length < 5 || q.endsWith(' ')) {
          _this.autocompleteSearchThrottled(_this.state.q.trim());
        } else {
          _this.autocompleteSearchDebounced(_this.state.q.trim());
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "autocompleteSearch", function (q) {
      _this.fetchAutoComplete(q);
    });

    _defineProperty(_assertThisInitialized(_this), "closeSearchBar", function () {
      if (_this.closingSearch === false) {
        _this.closingSearch = true;

        _this.searchRef.current.blur();

        _this.setState({
          activeSearch: false,
          search_text: ''
        });

        setTimeout(function () {
          return _this.closingSearch = false;
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openSearchBar", function () {
      if (_this.closingSearch === false) {
        _this.searchRef.current.focus();

        _this.setState({
          activeSearch: true
        });

        _this.props.closeMenu();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAutoComplete", function (q) {
      _this.qWaitingFor = q;

      if (q === _this.qWaitingFor) {
        var url = API_URL + '/products/autocomplete?term=' + _deburr(_this.state.q).toLowerCase().trim();

        var sap_id = document.querySelector('body').getAttribute('sap-id');

        if (sap_id) {
          url = url + '&sap_id=' + sap_id;
        }

        fetch(url).then(function (response) {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        }).then(function (data) {
          _this.setState({
            autoComplete: data
          });
        }).catch(function () {//   console.log(error)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyPress", function (e) {
      if (e.key === 'Enter') {
        _this.setState({
          autoComplete: []
        }, _this.doSearchURL(encodeURIComponent(_this.state.search_text)));
      }
    });

    _this.searchRef = /*#__PURE__*/React.createRef();
    _this.state = {
      search_text: '',
      autoComplete: '',
      activeSearch: false
    };
    _this.closingSearch = false;
    _this.autocompleteSearchDebounced = debounce(500, _this.autocompleteSearch);
    _this.autocompleteSearchThrottled = throttle(500, _this.autocompleteSearch);
    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onMouseOver = _this$props.onMouseOver,
          searchIcon = _this$props.searchIcon,
          searchIconReverse = _this$props.searchIconReverse;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-4 col-sm-6 col-md-6 col-lg-4 form-bar d-flex align-items-center justify-content-end"
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-bar",
        onClick: this.openSearchBar,
        onMouseOver: onMouseOver
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-btn d-sm-block d-none"
      }, translate('SEARCH', 'RECHERCHER')), /*#__PURE__*/React.createElement("div", {
        className: "search-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: searchIcon,
        alt: ""
      }))), /*#__PURE__*/React.createElement("form", {
        className: "col-12 d-flex align-items-center justify-content-end product-search  ".concat(this.state.activeSearch === true ? 'active' : ''),
        onSubmit: this.search,
        onBlur: this.closeSearchBar
      }, /*#__PURE__*/React.createElement("input", {
        className: "d-lg-flex",
        ref: this.searchRef,
        type: "text",
        placeholder: translate('Keywords or product code', 'Mot-clés ou code produit'),
        onChange: this.setSearchTxt,
        value: this.state.search_text,
        onKeyPress: this._handleKeyPress
      }), /*#__PURE__*/React.createElement("div", {
        className: "icon-box",
        onMouseDown: this.search
      }, /*#__PURE__*/React.createElement("img", {
        className: "search-icon",
        src: searchIconReverse,
        alt: ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "autoListe"
      }, this.state.autoComplete.length > 0 ? this.state.autoComplete.map(function (auto, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "autoListeItem",
          onMouseDown: function onMouseDown() {
            return _this2.autoCompleteClick(auto.value);
          }
        }, auto.label);
      }) : null)));
    }
  }]);

  return Search;
}(Component);

Search.propTypes = {
  closeMenu: PropTypes.func,
  history: PropTypes.object,
  onMouseOver: PropTypes.func,
  searchIcon: PropTypes.string,
  searchIconReverse: PropTypes.string
};
export default Search;